import { render, staticRenderFns } from "./MyHabitsRatingSlider.vue?vue&type=template&id=f12145aa"
import script from "./MyHabitsRatingSlider.vue?vue&type=script&lang=js"
export * from "./MyHabitsRatingSlider.vue?vue&type=script&lang=js"
import style0 from "./MyHabitsRatingSlider.vue?vue&type=style&index=0&id=f12145aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports